import { Menu, MenuItem } from '@mui/material';
import { useHistory } from 'react-router-dom';
import React from 'react';

export default function QuickMenu({
  anchorEl,
  onClose = () => {},
  links,
  ...rest
}) {
  const history = useHistory();
  const handleClick = id => {
    history.push(`#${id}`);
    onClose();
  };

  return (
    <Menu anchorEl={anchorEl} keepMounted open={!!anchorEl} {...rest}>
      {links.map(({ id, title }) => (
        <MenuItem
          key={`quickNav_${id}`}
          onClick={() => handleClick(id)}
          value={id}
        >
          {title}
        </MenuItem>
      ))}
    </Menu>
  );
}
